"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

var _utils2 = require("./utils");

var _ChartItem = _interopRequireDefault(require("./ChartItem"));

var _ChartLabels = _interopRequireDefault(require("./ChartLabels"));

var _ChartLegend = _interopRequireDefault(require("./ChartLegend"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function BandwidthChart(props) {
  var data = props.data,
      labelFormat = props.labelFormat,
      numberFormat = props.numberFormat,
      labelWidth = props.labelWidth,
      className = props.className,
      labelNew = props.labelNew,
      labelCurrent = props.labelCurrent;
  var hasNew = (0, _utils2.checkData)(data);

  var _getHeight = (0, _utils2.getHeight)(data, hasNew),
      height = _getHeight.height,
      chartHeight = _getHeight.chartHeight;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var labels = (0, _utils2.getLabels)(data, labelFormat);
  var labelSize = (0, _utils2.getLabelWidth)(labelWidth, width);
  var dataArray = (0, _utils2.buildSingleDataArrays)(data, width, labels, labelSize, labelFormat, numberFormat);
  var xAxis = (0, _utils2.getXAxis)(labelSize, chartHeight);
  var legendCoordinates = (0, _utils2.getLegendCoordinates)(width, chartHeight, labelNew, labelCurrent);

  var refCallback = function refCallback(element) {
    if (!width && element) {
      setWidth(element.getBoundingClientRect().width);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _utils.getClassNames)(className, 'bandwidth-chart-container'),
    ref: refCallback
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    version: "1.1",
    className: "chart-root",
    viewBox: "0 0 ".concat(width, " ").concat(height)
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: xAxis,
    className: "chart-xaxis-line"
  }), dataArray.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_ChartItem.default, {
      key: (0, _utils.createUniqueKey)(index, item.label),
      data: item,
      index: index
    });
  }), hasNew && /*#__PURE__*/_react.default.createElement(_ChartLegend.default, {
    data: legendCoordinates,
    labelNew: labelNew,
    labelCurrent: labelCurrent
  })), /*#__PURE__*/_react.default.createElement(_ChartLabels.default, {
    labels: labels
  }));
}

BandwidthChart.propTypes = {
  /** Data to be shown on chart */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    data: _propTypes.default.shape({
      curr: _propTypes.default.number.isRequired,
      new: _propTypes.default.number
    }).isRequired,
    range: _propTypes.default.shape({
      min: _propTypes.default.number.isRequired,
      max: _propTypes.default.number.isRequired
    }).isRequired
  })),

  /** Width for label of chart (default 150px) */
  labelWidth: _propTypes.default.number,

  /** Formats of labels */
  labelFormat: _propTypes.default.func,

  /** Formats of numbers (without percent) */
  numberFormat: _propTypes.default.func,

  /** Label for current value */
  labelCurrent: _propTypes.default.string,

  /** Label for new value */
  labelNew: _propTypes.default.string,
  className: _propTypes.default.string
};
BandwidthChart.defaultProps = {
  data: [],
  labelNew: '',
  className: '',
  labelWidth: 150,
  labelCurrent: '',
  labelFormat: function labelFormat(name) {
    return name;
  },
  numberFormat: function numberFormat(number) {
    return number;
  }
};
var _default = BandwidthChart;
exports.default = _default;